import React from 'react';
import './index.css';

export const Label20 = ({ bold=false, children }) => {
    const textStyle =  { fontWeight: (bold) ? '600': 'normal' };
    return <label className="label20" style={textStyle}>{children}</label>;
};